import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-modal-generic',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './modal-generic.html',
  styles: `
    .scrim {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.18);
      z-index: 22;
    }

    .sheet {
      position: fixed;
      right: 10%;
      bottom: 35%;
      left: 10%;
      top: 20%;
      z-index: 23;
      max-width: 54rem;
      margin: 0 auto;
      padding: 0 0 calc(1.2rem + env(safe-area-inset-bottom));
      border-radius: 1.25rem;
      background: var(--color-background, white);
      color:var(--color-text-mute, darkgray);
      box-shadow: 0 -1rem 3rem rgba(0, 0, 0, 0.16);
      display:flex; flex-direction:column;
      align-items:center; justify-content:space-between;
      overflow:hidden;
      font-size:24px;
      @media (max-width: 720px) {
        font-size: 14px;
      }
      font-weight: bold;
      text-align:center;
    }
      
  `,
})
export class ModalGeneric {
  open = input(true);
  label = input('');
}